import { motion } from "framer-motion";

const CHAPTERS = [
  {
    num: "01", title: "THE SHOW", sub: "Can You Make the Cut?",
    text: "Real people. Real adventures. The first reality series where maritime skills meet maritime challenges — shot entirely on open water.",
  },
  {
    num: "02", title: "THE SKILLS", sub: "What It Takes",
    text: "Rigging, night navigation, storm drills and raw seamanship. Every challenge earned under real conditions. Nothing staged, nothing scripted.",
  },
  {
    num: "03", title: "THE CREW", sub: "Captains & First Mates",
    text: "Authority and trust tested across the channel. Every crew member voted in by the community — your vote decides who takes the helm.",
  },
  {
    num: "04", title: "THE FIRST ADVENTURE", sub: "Catalina Island",
    text: "Twenty-six miles of open Pacific. The maiden voyage that started it all — Avalon Harbor, Catalina Island: 33°20'46\"N, 118°19'32\"W.",
  },
];

export const Manifesto = () => (
  <section id="show" className="relative max-w-7xl mx-auto px-5 md:px-8 py-24 md:py-36" data-testid="manifesto-section">
    <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} transition={{ duration: 0.8 }}
      className="text-[11px] tracking-[0.5em] uppercase text-[#D4AF37]" data-testid="manifesto-caption">
      The Manifesto
    </motion.p>
    <motion.h2 initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
      transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
      className="font-display text-2xl sm:text-3xl lg:text-4xl tracking-[0.08em] text-[#F5F3EF] mt-4" data-testid="manifesto-heading">
      FOUR CHAPTERS. <span className="gold-text">ONE STANDARD.</span>
    </motion.h2>

    <div className="mt-16 md:mt-24 space-y-20 md:space-y-28">
      {CHAPTERS.map((c, i) => (
        <motion.div
          key={c.num}
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className={`flex gap-6 md:gap-12 items-start max-w-2xl ${i % 2 === 1 ? "md:ml-auto" : ""}`}
          data-testid={`manifesto-chapter-${c.num}`}
        >
          <span className="font-display text-6xl md:text-8xl leading-none text-transparent shrink-0"
            style={{ WebkitTextStroke: "1px rgba(212,175,55,0.4)" }}>
            {c.num}
          </span>
          <div className="border-l border-[#D4AF37]/25 pl-6 md:pl-10">
            <h3 className="font-display text-xl md:text-2xl tracking-[0.15em] text-[#E8C15A]">{c.title}</h3>
            <p className="font-editorial italic text-lg md:text-xl text-[#F5F3EF]/80 mt-1">{c.sub}</p>
            <p className="text-sm md:text-base text-[#94A3B8] leading-relaxed mt-3">{c.text}</p>
          </div>
        </motion.div>
      ))}
    </div>
  </section>
);
